'use client';

import { usePathname } from 'next/navigation';

import { trackAnalyticsEvent } from '@/app/lib/analytics';
import { ANALYTICS_EVENTS } from '@/constants';

import { Button } from '../button';

type PrimaryButtonProps = {
  title: string;
  link: {
    href?: string;
    target?: string;
    download?: boolean;
  };
};

export const PrimaryButton = ({ title, link }: PrimaryButtonProps) => {
  const pathname = usePathname();
  return (
    <Button
      variant="primary"
      {...link}
      onClick={() => {
        if (pathname.includes('sign-up') && title.includes('Powerpacks')) {
          trackAnalyticsEvent(ANALYTICS_EVENTS.signup.powerpack);
        }
      }}
    >
      {title}
    </Button>
  );
};
